import React, { Component } from 'react';
import Input from '../forms/input';

class ApiKey extends Component {
  state = {};
  render() {
    return (
      <div className="gb-settings-container">
        <Input
          label="API Key"
          name="apikey"
          value={this.props.value}
          onChange={this.props.handleInputChange}
        />
      </div>
    );
  }
}

export default ApiKey;



// WEBPACK FOOTER //
// ./src/components/settings/apiKey.jsx